import { IconButton } from '@mui/material';
import { ColumnDef } from '@tanstack/react-table';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { useState } from 'react';
import { BiSolidEdit } from 'react-icons/bi';

import TableData from '@/components/atoms/TableData';
import SystemParameterModal from '@/components/molecules/SystemParametersModal';

import {
	getParameterDescription,
	SystemParameter,
} from '../SystemParametersConstants';

export const columns: Array<ColumnDef<SystemParameter>> = [
	{
		accessorKey: 'description',
		header: 'PARÂMETRO',
		meta: {
			headerClassName: 'text-white bg-[#193CB9] rounded-tl-lg pl-2',
		},
		cell: (props) => (
			<TableData
				tableValue={props.getValue()}
				className="w-96 overflow-hidden text-ellipsis whitespace-nowrap px-2"
				title={props.getValue() as string}
			/>
		),
	},
	{
		accessorKey: 'value',
		header: 'PERÍODO (DIAS ÚTEIS)',
		meta: {
			headerClassName: 'text-white bg-[#193CB9]',
		},
		cell: (props) => (
			<TableData
				tableValue={props.getValue()}
				className="w-44 overflow-hidden text-ellipsis whitespace-nowrap"
				title={props.getValue() as string}
			/>
		),
	},
	{
		accessorKey: 'updatedAt',
		header: 'ÚLTIMA ATUALIZAÇÃO',
		meta: {
			headerClassName: 'text-white bg-[#193CB9]',
		},
		cell: (props) => {
			const date = props.getValue() as Date;
			const formattedDate = date
				? format(new Date(date), 'dd/MM/yyyy HH:mm', { locale: ptBR })
				: '';
			return (
				<TableData
					tableValue={formattedDate}
					className="w-44 overflow-hidden text-ellipsis whitespace-nowrap"
					title={formattedDate}
				/>
			);
		},
	},
	{
		accessorKey: 'updatedBy',
		header: 'AUTOR',
		meta: {
			headerClassName: 'text-white bg-[#193CB9]',
		},
		cell: (props) => (
			<TableData
				tableValue={props.getValue()}
				className="w-64 overflow-hidden text-ellipsis whitespace-nowrap"
				title={props.getValue() as string}
			/>
		),
	},
	{
		id: 'edit',
		meta: {
			headerClassName: 'text-white bg-[#193CB9] rounded-tr-lg',
		},
		header: '',
		cell: (value) => {
			const [isModalOpen, setIsModalOpen] = useState(false);
			const name = value.row.original.name;
			const description = getParameterDescription(name);

			const handleOpenModal = () => {
				setIsModalOpen(true);
			};

			return (
				<div className="w-16">
					<IconButton
						sx={{
							margin: 1,
							height: '2.5rem',
							width: '2.5rem',
							color: '#1F3FA8',
							'&:hover': {
								color: '#4c4c73',
							},
							'&:disabled': {
								color: '#9ca3af',
							},
						}}
						aria-label="edit"
						onClick={handleOpenModal}
						disabled={isModalOpen}
					>
						<BiSolidEdit size={20} />
					</IconButton>
					{isModalOpen && (
						<SystemParameterModal
							parameter={value.row.original}
							modalIsOpen={isModalOpen}
							handleClose={() => {
								setIsModalOpen(false);
							}}
							confirmationText={description}
						/>
					)}
				</div>
			);
		},
	},
];
